import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Card from 'bundles/apex/card';
import HistoryEmptyState from './empty_state';
import Row from './row';

export function HistoryCard({ history, stagesConfig }) {
  return (
    <div className="d-flex flex-column gap-3">
      <h5 className="py-3">History</h5>
      <Card
        className="deal-history-card d-flex flex-column"
        overflowAuto
        verticalBody
      >
        {history.length > 0 ? (
          history.map((event, i) => {
            return <Row event={event} key={i} stagesConfig={stagesConfig} />;
          })) :
          <HistoryEmptyState />
        }
      </Card>
    </div>
  );
}

HistoryCard.propTypes = {
  history: PropTypes.array,
  stagesConfig: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    history: state.deal.stageHistory,
    stagesConfig: state.stagesConfig,
  };
};

export default connect(mapStateToProps)(HistoryCard);
